import React from "react";
import "./adminMenu.css";

export function AdminSettingsShell({title, meta, sidebar, children}) {
    return (
        <div className="admin-settings-shell">
            <header className="admin-settings-hero">
                <div className="admin-settings-hero__inner">
                    {meta && <p className="admin-settings-hero__meta">{meta}</p>}
                    <h1 className="admin-settings-hero__title">{title}</h1>
                    <p className="admin-settings-hero__desc">
                        시스템 전역 옵션입니다. 변경 사항은 저장 즉시 반영됩니다.
                    </p>
                </div>
            </header>
            <div className="admin-settings-workspace">
                <aside className="admin-settings-sidebar" aria-label="설정 구분">
                    {sidebar}
                </aside>
                <main className="admin-settings-main">{children}</main>
            </div>
        </div>
    );
}

export function AdminSettingsNavItem({targetId, label, active, onClick}) {
    return (
        <button
            type="button"
            className={`admin-settings-nav__item${active ? " is-active" : ""}`}
            onClick={() => onClick(targetId)}
        >
            {label}
        </button>
    );
}

export function AdminSettingsPanel({title, description, children}) {
    return (
        <section className="admin-settings-panel">
            <header className="admin-settings-panel__head">
                <h2 className="admin-settings-panel__title">{title}</h2>
                {description && <p className="admin-settings-panel__desc">{description}</p>}
            </header>
            <div className="admin-settings-panel__body">
                <AdminSettingsKvTable>{children}</AdminSettingsKvTable>
            </div>
        </section>
    );
}

export function AdminSettingsKvTable({children}) {
    return (
        <table className="admin-settings-kv-table">
            <colgroup>
                <col className="admin-settings-kv-col-label"/>
                <col className="admin-settings-kv-col-value"/>
            </colgroup>
            <tbody>{children}</tbody>
        </table>
    );
}
